module.exports = { existsSync: () => true };